<template>
  <div v-if="contract.id" class="form-detail">
    <h1>Thông tin người đại diện</h1>
    <Content title="Họ và tên" :content="item.customerName"></Content>
    <Content title="Email" :content="item.authoriserEmail"></Content>
    <Content title="Số điện thoại" :content="item.authoriserContactNumber"></Content>
    <Content title="Chức vụ" :content="item.position"></Content>
    <Content title="Số CMND/CCCD/HC" :content="item.passport"></Content>
    <Content title="Nơi cấp" :content="item.placeOfIssue"></Content>
    <Content title="Ngày tháng năm sinh" :content="item.birthDay | formatDate"></Content>
    <Content title="Địa chỉ thường trú" :content="item.authoriserAddress1"></Content>
    <Content title="Địa chỉ hiện tại" :content="item.authoriserAddressPresent"></Content>
  </div>
</template>
<script>
  import Content from './Content.vue'
  export default {
    props: {
      item: {
        type: Object,
        default: () => {},
      },
      contract: {
        type: Object,
        default: () => {},
      },
    },
    components: { Content },
    data() {
      return {}
    },
    computed: {},
  }
</script>

<style scoped></style>
